import { logger } from "@octopusdeploy/logging";
import { useInlineStatusQuery } from "@octopusdeploy/octopus-react-client";
import type { LicensedFeature } from "@octopusdeploy/octopus-server-client";
export function useIsLicensedFeatureEnabled(feature: LicensedFeature): boolean {
    const { result: features, error } = useInlineStatusQuery(async (repository) => await repository.Licenses.getFeatures(), [], "Get licensed features");
    if (error) {
        logger.warn(`Error fetching licensed features: ${error.message}`);
        return false;
    }
    return features ? features.EnabledFeatures.includes(feature) : false;
}
